import Speaker1 from "../assets/images/speaker1.jpg";
import Speaker2 from "../assets/images/Speakers-02.png";
import Speaker3 from "../assets/images/Speakers-03.png";
import Speaker5 from "../assets/images/Speakers-05.png";
import Speaker6 from "../assets/images/Speakers-04.png";

import hiruka from "../assets/images/სპიკერები-03.png";
import xudura from "../assets/images/სპიკერები-01.png";
import markf from "../assets/images/სპიკერები-02.png";

import ger from "../assets/images/ger.png";
import tam from "../assets/images/Photo - Tamar Gabunia-02.png";

import sergio from "../assets/images/სერგიო-28.png";

import GrayUser from "../assets/images/rrrrrrrr.png";

import Tevzadze from "../assets/images/tevzadze.png";
import tbc from "../assets/images/tbc.png";
import Student from "../assets/images/stud.png";

import SR from "../assets/images/rrrrrAAAA.png";

import ninoTand from "../assets/speakers2024/ninoTand.png";
import mariaPie from "../assets/speakers2024/mariaPie.png";
import papasKaci from "../assets/speakers2024/papsi.png";
import csillia from "../assets/speakers2024/csilla.jpg";
import drCurt from "../assets/speakers2024/curt.png";
import coplin from "../assets/speakers2024/coplin.jpg";
import kenichi from "../assets/speakers2024/kenichi.jpg";
import lela from "../assets/speakers2024/lelap.jpg";
import benny from "../assets/speakers2024/benny.jpeg";
import ira from "../assets/speakers2024/ira.jpg";
import sodoni from "../assets/speakers2024/sodoni.jpg";

export const speakersArrEng2024 = [
  {
    id: 0,
    name: "Nino Tandilashvili",
    position: `The First Deputy
Minister of the Ministry of Environmental
Protection and Agriculture of Georgia`,
    description: `Ms. Nino Tandilashvili is the first Deputy Minister of the Ministry of Environmental
Protection and Agriculture of Georgia from April 2023 (She was Deputy Minister of
Environmental Protection and Agriculture of Georgia between 12.2017- 04.2023).
She is in charge of key national environmental policy directions including climate
change, ambient air protection, water resources management, environmental
permits and licensing, as well as development of legal framework, international
relations and European Integration, facilitation of environmental education,
supporting public participation in decision-making and ensuring access to
information. Moreover, monitoring of environmental pollution, monitoring of
meteorological, hydrological, geological processes, as well as collection and
dissemination of environmental monitoring data at national and international levels
falls under the custodianship.
Prior to her current position, Ms. Tandilashvili was Deputy Head of the Legal
Department of the Ministry of Environment and Natural Resources Protection of
Georgia and was responsible for elaboration of environmental legislation and
coordination of legal aspects of environmental dimensions for the EU integration.
Starting from 2007 she has developed an interesting and extensive career and has
gained significant experience in the fields of lawmaking and environmental
protection. She has graduated her bachelor in law from Tbilisi State University,
Master in European and Internation Law from University of Amsterdam. She has
started her career as a public servant at the Ministry of Penitentiary, Probation and
Legal Assistance of Georgia, from 2014 she was holding different positions at the
Ministry of Environment, as the Head of the Division of Parliamentary Affairs and
Lawmaking, Deputy head of the Legal Department of the Ministry of Environment
and Natural Resources Protection of Georgia (2014-2017).
In addition to her successful career Ms. Tandilashvili has made a significant
contribution in development of strategic environmental documents such as “The
Environmental Assessment Code of Georgia”, “The Law on Radioactive Waste
Management of Georgia”,
“The Law on Water Resources Management of Georgia”, “The Law on Industrial
Emmissions of Georgia”, “The Law on Environmental Liability of Georgia”, “Ambient
Air Quality Management Legislation”. She is also an Assistant Professor at the
Georgian Institute of Public Affairs and reading lectures for master students.`,
    img: ninoTand,
  },
  {
    id: 1,
    name: "Dr. MARIA PIA ANCORA",
    position: `Senior Urban Development Specialist, ADB Sectors Group`,
    description: `For the past 20 years, Maria Pia has designed and implemented sustainable investment
programs and offered environmental policy advisory across Asia (China, India,
Mongolia, Pakistan, and others). Based in the dynamic South Caucasus since 2019,
she oversees ADB’s urban, water, and climate programs in the region.
Hailing from Italy, she holds a Master’s degree in Environmental Engineering and Land
Use Planning from the University of Trento and a Ph.D. in Environmental Science and
Engineering from Tsinghua University in Beijing, P.R. China.`,
    img: mariaPie,
  },
  {
    id: 2,
    name: "Dr. Ioannis PAPPAS",
    position: `Director Mediterranean Region, Global Sustainable Tourism Council
CEO &amp; Founder, Green Evolution AE`,
    description: `Dr. Ioannis PAPPAS, Founder &amp; CEO of GREEN EVOLUTION SA. is Director for Mediterranean Region
of the Global Sustainable Tourism Council (GSTC). He is a Mechanical Engineer, with PhD in Applied
Mechanics, with over 30 years’ experience in several fields of science, focusing in Sustainability for
Tourism, Energy and Environmental Efficiency in Infrastructure and Buildings, Advising in
standardization of companies and technological implementation of climate adaptation and
mitigation methodologies. He is Lead GSTC Assessor for Destinations, Auditor / Assessor for
Sustainable Tourism Certification Standards, focusing on Hotels, Tour Operators and Destinations,
Lead Trainer and Assessor for GSTC in South East Europe Region. He was an invited speaker in a
large number of seminars and webinars, including European Commission, GSTC and Google.`,
    img: papasKaci,
  },
  {
    id: 3,
    name: "Csilla Mezösi",
    position: "Secretary-General, European Spas Association (ESPA)",
    description: `Csilla Mezősi has been involved in the activities of the European Spas (ESPA) since 2000,
and she has held the position of Secretary-General since 2018. Throughout her career, she
has been engaged in strategic project management for urban and national government
administrations, focusing on the development of projects in the Health Tourism sector.
With over 25 years of experience in the international tourism industry, she has primarily
concentrated on tourism abroad and networks. Ms. Mezősi&#39;s extensive experience
encompasses various areas such as B2B and B2C sales activities, international PR, event
organization, management consultancy, Spa development, cross-marketing for tourism and
healthcare companies, medical tourism promotion, and representing medical spas for health
insurance companies. In her role as Secretary-General, she is actively involved in the EU
Tourism Manifesto Group and has initiated numerous activities and collaborations in the
overseas market with the specialization of well-being, health tourism, and innovations in the
spa business.`,
    img: csillia,
  },
  {
    id: 4,
    name: "Dr. Kenichi HASHIMOTO",
    position: `
Chairman, 9steps Corporation of Japan`,
    description: `
Japanese architect and urban planner. Graduated from Tokyo Institute of Technology.
He started his professional career in the 1990s in France for integrated resort stations in European and Asian countries. The representative projects are;
- Les Coches (Ski resort station, Savoie, France)
- Port Bourgenay (Coastal and balneological resort, Morbihan, France)
- Cap Esterel (Coastal resort, Var, France)
- Zao Sunheim (Ski and balneological resort, Yamagata, Japan)
From 2002 to 2005, he worked as a general manager of the design division in Kisho KUROKAWA Architect and Associates. He was in charge for;
-	Urban planning for the new capital planning for Astana city (Capital city planning, Kazakhstan)
-	Zheng Dong New Town urban planning and spatial design (Sub-city planning, Heinan, PRC)
-	Delhi and Mumbai airport city planning (Urban development planning and design, India)
Since 2005, he established and manages his urban planning and architect office. The major field is urban planning, architecture and spatial design, and development planning. In the resort-related field, he has been involved in the following projects.
- Madarao Ski Resort spatial redevelopment planning (Nagano, Japan, 2014)
- Niseko Ski Resort Hotel construction advisory services (Hokkaido, Japan, 2017)
- Kazakhstan/Kyrgyz mountain area tourism development planning (2019)
- Turgen Gorge Ski Resort development planning (Kazakhstan, 2021)
- Tripura state resort development planning (India, 2023)
- Consultation for Georgia national resort development planning (2024)
Award:
1st Prize of Privatization Planning for Sendai Airport Planning (2014, Miyagi, Japan)
1st Prize of Cheng Dong New Town Longzi Lake Area Planning (2003, Heinan, PRC) UNESCO Melina Mercouri Prize (2005, Koga Park, Ibaraki, Japan)
`,
    img: kenichi,
  },
  {
    id: 5,
    name: "Dr. Kurt von Storch",
    position: `CEO, EuropeSpa med &amp; wellness GmbH, Wiesbaden
General Secretary, Quality in Health Prevention
Vice-President, the Academy of Balneology and Climatology of Germany`,
    description: `Dr. Kurt von Storch is a leading expert in the mineral water and spa. He is the CEO of
EuropeSpa med &amp; wellness GmbH, Wiesbaden; General Secretary of Quality in Health
Prevention e.V., Wiesbaden; and Vice-President of the Academy of Balneology and Climatology
(VBK e.V.), the German medical spa expert association. Additionally, he is a scientific member
of the German Spas Association. Dr. von Storch also served as General Secretary of the
Commission on Mineral and Thermal Waters (CMTW) of the IAH International Association of
Hydrogeologists until 2009.
Since 2006, he has been the CEO of EuropeSpa med &amp; wellness GmbH and STORCH Water
Consulting International, Germany. His achievements include: Creation of quality standards and
certification systems for medical and wellness facilities; Conducting training courses on topics
such as thermal water, mud, and climate as therapeutic agents in balneology, as well as quality
aspects in wellness facilities and medical spas; Consulting on the development of local natural
resources, such as thermal water springs, into touristic health destinations.
The previous positions of Dr. Kurt von Storch included:
1999–2005: Institute Fresenius, Germany: Responsible for quality assurance (microbiological
and chemical aspects) in health clinics, health hotels, wellness hotels, spas, and bottling
companies.
1994–1998: UFZ Environmental Research Centre, Germany: Conducted research on mineral and
thermal waters, focusing on quality protection for the spa business; completed a doctoral thesis
on this subject.
Awards:
 Financial Times Germany (2009) for the EuropeSpa med concept
 Two entrepreneur awards from the German state of Hesse and the city of Wiesbaden`,
    img: drCurt,
  },
  {
    id: 6,
    name: "Dr. Marcus Coplin",
    position: `President, the Balneology Association of North America (BANA)`,
    description: `Dr. Marcus Coplin is a president of the Balneology Association of North America
(BANA). He is a Naturopathic Medical Doctor specializing in the field of integrative
Physical &amp; Rehabilitation Medicine and integrative Oncology. He has over 15 years
experience in the treatment of complex and chronic illnesses using hydrothermal
therapy, nutrition, physical medicine, and natural medicines in conjunction with
conventional treatment.
He is the leading specialist in Hydrothermal Medicine in North America and is the
Medical Director for The Springs Resort in Pagosa Springs, CO and Murrieta Hot
Springs Resort in Murrieta, CA. He advises on the science-informed use of therapeutic
thermal mineral hot spring water and Health Resort programming.
Dr. Coplin writes and teaches extensively on the re-emergence of Health Resort culture
and programming in the 21st century healthcare and tourism fields. He is the editor-in-
chief for the International Journal of Balneology and Health Resort Medicine and a book
entitled, Health Resort Medicine. He currently consults other practice owners on
structuring their business to deliver high quality patient centered care integrating
treatment centers, technology, patient care systems, and clinical mechanics to deliver a
high value and profitable patient experience. DrCoplin.Com`,
    img: coplin,
  },
  {
    id: 7,
    name: "Assoc. Professor Lela Potskhverashvili",
    position: `Deputy-Director, LEPL Resorts Development Agency`,
    description: `Associate Professor Lela Potskhverashvili has been serving as the Deputy Director of the Resort Development Agency under the Ministry of Economy and Sustainable Development of Georgia since 2022. Since 2016, she has led the Department of International Relations and Analytics at MTA LLC. She is also an Associate Professor at New Anglia University in the UK and a Visiting Lecturer at Ilia State University.
With over 15 years of experience in the public and private sectors, as well as in local and international organizations, Lela Potskhverashvili specializes in economics, tourism, international relations, humanitarian law, and related fields. She worked on conventions, strategies, and action plans in various areas of state policy. 
Since 2012, she has served as a project manager and expert for the Eastern Partnership and Visegrad countries, working on projects related to economic sustainability, tourism, and the integration of socially vulnerable groups.
Lela Potskhverashvili is a Fellow of the Fund for American Studies, the Ministry of Foreign Affairs of Poland, and the International Visegrad Fund. She holds a Master of Arts degree from Lancaster University in the UK and a Master’s degree in International Relations from Tbilisi State University. She is currently pursuing a PhD in International Relations at Tbilisi State University. Her most recent publication is "The Power of National Identity in the Foreign Policy of Georgia."
`,
    img: lela,
  },
  {
    id: 8,
    name: "Benny Pregenzer",
    position: `Founder pro excellence`,
    description: `Benny Pregenzer is an experienced leader in the alpine tourism industry, recognized for his innovative approach to enhancing both winter and summer resort experiences. His career began in Austria in 1982 as a ski instructor, and over the years, he expanded into resort management and development. Pregenzer’s work is marked by a strong focus on "convenience," aiming to improve the guest experience in alpine destinations. He was notably involved in introducing ski lifts with conveyor belts and practical ski depots, making skiing more accessible, especially for families and beginners.
From 2011 to 2023, Pregenzer served as the Managing Director of Fisser Bergbahnen GmbH, where he was responsible for overseeing ski lift operations, slope management, and the development of year-round offerings, such as the bike park and summer activities. His vision was key in transforming the region into a year-round destination, complementing the winter tourism business by developing a strong summer tourism infrastructure. His leadership experience also includes managing the Falls Creek Ski School and Race Department, as well as the Fiss-Ladis Ski School, further cementing his expertise in ski resort operations.
He has also played an influential role internationally, contributing to the development of masterplans for resorts like Falls Creek (Australia), Niseko (Japan), and Donovaly (Slovakia), including analysing potential developments in Palandöken and Konakli (Turkey). Additionally, Pregenzer founded Fiss-Consulting in 2007, offering his expertise in ski resort management and development.
In 2023, he launched "pro excellence," a consultancy and project development company, continuing to drive innovation in the alpine tourism sector.
`,
    img: benny,
  },
  {
    id: 9,
    name: "Irakli Burtchuladze",
    position: `Director, MTA`,
    description: `Irakli Burchuladze is a management and financial professional with more than 13 years of work experience in public and private sectors. He holds Master of Science in Finance and bachelor's degree in International Economic Relations. His experience in private sector includes the development of business models and financial solutions, management strategies and action plans. He started professional career in public sector by working on two major reforms in Georgia, the pension and the capital market reforms. After earning MSc degree, he became the CFO of the newly created Pension Agency, sole body responsible for the collection and management of pension contributions. After short tenure at the Pension Agency, Irakli was promoted to the position of the Deputy Chief of Staff to the Prime Minister of Georgia. His main responsibility was financial management of the PM's office.
As the Director of MTA, he oversees the operations of Georgia's premier mountain and ski resorts, including Gudauri, Bakuriani, Goderdzi, and Mestia.
Since becoming Director of M.T.A. LLC in 2022, Irakli Burchuladze has led numerous transformative initiatives for Georgia's mountain resorts. His leadership was pivotal in making Georgia a host country for the Freeride World Tour, with Mestia becoming the home of Freeride. His successful cooperation with FIS led Georgian ski resorts to become annual hosts of the World Championships. Alongside these events, Irakli spearheaded key infrastructural projects, enhancing resort facilities and operations. His work continues to strengthen Georgia’s position on the global winter sports stage.

`,
    img: ira,
  },
  {
    id: 10,
    name: "Dr. John Sawdon",
    position: `An environmental economist with over 18 years of professional experience in Europe and the Asia and the Pacific. `,
    description: `John Sawdon is an environmental economist with over 18 years of professional experience in Europe and the Asia and the Pacific. He holds a PhD in Development Economics from the University of East Anglia, UK and an MSc in Economics from the School of Oriental and African Studies at the University of London, UK.  John has worked extensively on projects related to climate change adaptation, hydropower and renewable energy, green urban development, nature-based solutions and sustainable tourism, for international organizations such as the ADB, World Bank and UNDP, as well as various government agencies. Aside from Georgia he has worked on tourism projects in countries including Fiji, Nepal and Vietnam.
`,
    img: sodoni,
  },
];
export const speakersArrGeo2024 = [
  {
    id: 0,
    name: "ნინო თანდილაშვილი",
    position: `საქართველოს გარემოს დაცვისა და
სოფლის მეურნეობის მინისტრის
პირველი მოადგილე`,
    description: `ქალბატონი ნინო თანდილაშვილი 2023 წლის აპრილიდან არის
საქართველოს გარემოს დაცვისა და სოფლის მეურნეობის მინისტრის
პირველი მოადგილე (მინისტრის მოადგილე - 12.2017- 04.2023 წლებში). ის
პასუხისმგებელია ეროვნული გარემოსდაცვითი პოლიტიკის ძირითად
მიმართულებებზე, მათ შორის, კლიმატის ცვლილება, ატმოსფერული
ჰაერის დაცვა, წყლის რესურსების მართვა, ასევე საკანონმდებლო ჩარჩოს
შემუშავება, გარემოსდაცვითი განათლებისა და გარემოსდაცვითი
გადაწყვეტილებების მიღების პროცესში საზოგადოების მონაწილეობის
ხელშეწყობა და გარემოსდაცვით ინფორმაციასთან ხელმისაწვდომობის
უზრუნველყოფა. გარდა ამისა, მისი პასუხისმგებლობის ქვეშ არის ისეთი
საკითხები, როგორიც არის გარემოს დაბინძურების მონიტორინგი,
მეტეოროლოგიური, ჰიდროლოგიური და გეოლოგიური პროცესების
მონიტორინგი, ასევე გარემოზე დაკვირვების მონაცემთა შეკრება და
ეროვნულ და საერთაშორისო დონეებზე გავრცელება.
ამჟამინდელ პოზიციამდე, ქალბატონ ნინო თანდილაშვილს ეკავა გარემოსა
და ბუნებრივი რესურსების დაცვის სამინისტროში იურიდიული
დეპარტამენტის ხელმძღვანელის მოადგილის პოზიცია და პასუხისმგებელი
იყო გარემოსდაცვითი კანონმდებლობის მომზადებასა და გარემოსდაცვითი
მიმართულებით ევროკავშირთან ინტეგრაციასთან დაკავშირებული
სამართლებრივი ასპექტების კოორდინაციაზე.
2007 წლიდან, ქალბატონი ნინოს კარიერა საინტერესოდ და მრავალმხრივ
განვითარდა და მან შეიძინა მნიშვნელოვანი გამოცდილება
სამართალშემოქმედებისა და გარემოსდაცვით სფეროებში. მან დაასრულა
სამართლის საბაკალავრო პროგრამა ივანე ჯავახიშვილის სახელობის
თბილისის სახელმწიფო უნივერსიტეტში, ასევე მიენიჭა ამსტერდამის
უნივერსიტეტის მაგისტრის აკადემიური ხარისხი ევროპულ და

საერთაშორისო სამართალში.
ქალბატონმა ნინომ პროფესიული საქმიანობა დაიწყო სასჯელაღსრულების,
პრობაციისა და იურიდიული დახმარების საკითხთა სამინისტროში, როგორც
საჯარო მოხელემ, ხოლო 2014-2017 წლებში მას ეკავა პარლამენტთან
ურთიერთობისა და სამართალშემოქმედებითი სამმართველოს
ხელმძღვანელისა და იურიდიული დეპარტამენტის ხელმძღვანელის
მოადგილის პოზიციები საქართველოს გარემოსა და ბუნებრივი რესურსების
დაცვის სამინისტროში.
გარდა, წარმატებული პროფესიული საქმიანობისა, ქალბატონმა ნინო
თანდილაშვილმა მნიშვნელოვანი წვლილი შეიტანა ისეთი სტრატეგიული
გარემოსდაცვითი დოკუმენტების შემუშავებაში, როგორიც არის
„გარემოსდაცვითი შეფასების კოდექსი“, „რადიოაქტიური ნარჩენების
შესახებ“ საქართველოს კანონი, „საქართველოს კანონი წყლის რესურსების
მართვის შესახებ“, „საქართველოს კანონი სამრეწველო ემისიების შესახებ“,
„საქართველოს კანონი გარემოსდაცვითი პასუხისმგებლობის შესახებ“ და
„ატმოსფერული ჰაერის ხარისხის მართვის კანონმდებლობა“. ის ასევე, არის
საქართველოს საზოგადოებრივ საქმეთა ინსტიტუტის ასისტენტ-
პროფესორი და კითხულობს ლექციებს მაგისტრანტებისთვის.`,
    img: ninoTand,
  },
  {
    id: 1,
    name: "დოქტორი მარია პია ანკორა",
    position: `ურბანული განვითარების მთავარი სპეციალისტი, აზიის განვითარების ბანკი
(ADB)`,
    description: `მარია პია ანკორა ბოლო 20 წელია შეიმუშავებს და ახორციელებს მდგრადი
ინვესტირების პროგრამებს და სთავაზობს კონსულტაციებს გარემოსდაცვითი
პოლიტიკის მიმართულებით აზიაში (ჩინეთი, ინდოეთი, მონღოლეთი, პაკისტანი
და სხვა). 2019 წლიდან ზედამხედველობს აზიის განვითარების ბანკის (ADB)
ურბანულ, წყლისა და კლიმატის პროგრამებს სამხრეთ კავკასიის რეგიონში.
არის ტრენტოს უნივერსიტეტის (იტალია) გარემოსდაცვითი ინჟინერიისა და
მიწათსარგებლობის დაგეგმვის მაგისტრის ხარისხის მფლობელი აქვს ცინგხუას
უნივერსიტეტის (პეკინი, ჩინეთი) დოქტორის ხარისხი გარემოს დაცვით
მეცნიერებებსა და ინჟინერიაში.`,
    img: mariaPie,
  },
  {
    id: 2,
    name: "დოქტორი იოანის პაპასი",
    position: `გლობალური მდგრადი ტურიზმის (GSTC) ხმელთაშუაზღვის რეგიონის დირექტორი
GREEN EVOLUTION SA-ს დამფუძნებელი და აღმასრულებელი დირექტორი`,
    description: `დოქტორი იოანის პაპასი არის გლობალური მდგრადი ტურიზმის საბჭოს (GSTC)
ხმელთაშუა ზღვის რეგიონის დირექტორი. ფლობს გამოყენებითი მექანიკის
დოქტორის ხარისხს.
აქვს 30 წელზე მეტი ხნის სამეცნიერო გამოცდილება მდგრადი ტურიზმის,
ენერგეტიკის, ინფრასტრუქტურასა და მშენებლობაში გარემოს ეფექტურობის
საკითხებში. კომპანიებს უწევს ექსპერტულ კონსულტაციას კლიმატთან
ადაპტაციისა და გარემოზე ზემოქმედების შემცირების სტანდარტებთან
დაკავშირებით. არის კურორტების GSTC-ის შე წამყვანი შემფასებელი, მდგრადი
ტურიზმის სერტიფიცირების სტანდარტების აუდიტი, წამყვანი ტრენერი და
სამხრეთ-აღმოსავლეთ ევროპის რეგიონის GSTC-ის სტანდარტების (GSTC)
შემფასებელი. მომხსენებლის სტატუსით მიწვეული იყო არაერთ სემინარსა და
ვებინარზე, მათ შორის ევროკომისიაში, GSTC-სა და Google-ში.`,
    img: papasKaci,
  },
  {
    id: 3,
    name: "ჩილა მეზოსი",
    position: "ევროპის სპა ასოციაციის (ESPA) გენერალური მდივანი",
    description: `ჩილა მეზოსი 2000 წლიდან მუშაობს ევროპის სპა ასოციაციაში (ESPA) და 2018 წლიდან
არის გენერალური მდივანი. მისი საქმიანობა მოიცავს გამაჯანსაღებელი ტურიზმის
სექტორში ჩართული ცენტრალური მთავრობისა და ადგილობრივი თვითმმართველობის
ორგანოების სტრატეგიული პროექტების მართვას.
მას 25 წელზე მეტხნიანი გამოცდილება აქვს საერთაშორისო ტურიზმის ინდუსტრიის
სხვადასხვა სფეროში და ჩართულია ისეთ აქტივობებში როგორიცაა პროფესიული
ქსელები, B2B და B2C გაყიდვები, საზოგადოებასთან ურთიერთობა, ღონისძიებების
ორგანიზება, მენეჯმენტის კონსულტირება, სპა ინდუსტრიის განვითარება,
ტურისტული და ჯანდაცვის კომპანიების კროს მარკეტინგი, სამედიცინო ტურიზმის
პოპულარიზაცია და სპა ობიექტებსა და სადაზღვევო კომპანიებს შორის
თანამშრომლობის ხელშეწყობა.
გენერალური მდივნის როლში ის აქტიურადაა ჩართული ევროკავშირის ტურიზმის
მანიფესტის ჯგუფში EU Tourism Manifesto Group და არის ჯანმრთელობის,
გამაჯანსაღებელი ტურიზმისა და სპა ბიზნესის ინოვაციების არაერთი საერთაშორისო
აქტივობისა თუ თანამშრომლობის ინიციატორი.`,
    img: csillia,
  },
  {
    id: 4,
    name: "დოქტორი კენიჩი ჰაშიმოტო",
    position: `Nine Steps კორპორაციის აღმასრულებელი დირექტორი`,
    description: `დოქტორი კენიჩი ჰაშიმოტო იაპონელი არქიტექტორი და ქალაქ-მგეგმარებელია.  
არის Nine Steps კორპორაციის აღმასრულებელი დირექტორი (ტოკიო, იაპონია)
დაამთავრა ტექნოლოგიების ინსტიტუტი ტოკიოში.  პროფესიული კარიერა 1990-იან წლებში,  საფრანგეთში დაიწყო.  
განხორციელებული აქვს პროექტები ინტეგრირებული საკურორტო ადგილებისთვის ევროპისა და აზიის ქვეყნებში:
•	Les coches (სათხილამურო კურორტების სადგური, სავოიე, საფრანგეთი)
•	Port Bourgenay ( სანაპირო და ბალნეოლოგიური კურორტი, მორბიჰანი, საფრანგეთი)
•	Cap Esterel  (სანაპირო კურორტი, ვარ, საფრანგეთი)
•	Zao Sunheim ( სათხილამურო და ბალნეოლოგიური კურორტი, იამაგატა, იაპონია)

2002 წლიდან 2005 წლამდე მუშაობდა დიზაინის განყოფილების გენერალურ მენეჯერად Kisho KUROKAWA-ში, არქიტექტურის განყოფილებაში.  მის ფუნქციებში შედიოდა: 
•	ყაზახეთის დედაქალაქის, ასტანას ახალი ურბანული დაგეგმარება
•	ჩინეთში, ჩენგ დონგის ახალი ქალაქის  (Zheng Dong New Town)  ურბანული დაგეგმარება და სივრცითი დიზაინი, ასევე, ჰეინანის ქალაქგეგმარება. 
•	ინდოეთში, დელისა და მუმბაის აეროპორტების ქალაქგეგმარება (ურბანული განვითარების დაგეგმვა და დიზაინი)

2005 წლიდან დოქტორი კენიჩი ჰაშიმოტო ხელმძღვანელობს ქალაქგეგმარებისა და არქიტექტორის თავისსავე დაარსებულ ოფისს, რომლის ძირითადი საქმიანობაა ურბანული დაგეგმარება, არქიტექტურა, სივრცითი დიზაინი და განვითარების დაგეგმვა. 

დოქტორი კენიჩი ჰაშიმოტო ჩართულია შემდეგ პროექტებში:
•	მადარაოს სათხილამურო კურორტის სივრცითი განვითარების დაგეგმვა (ნაგანო, იაპონია, 2014 წელი)
•	Niseko Ski Resort Hotel სამშენებლო საკონსულტაციო მომსახურება ( ჰოკაიდო, იაპონია , 2017 წელი )
•	ყაზახეთი/ყირგიზეთის მთის ზონის ტურიზმის განვითარების დაგეგმვა (2019)
•	ტურგენის ხეობის სათხილამურო კურორტის განვითარების დაგეგმვა (ყაზახეთი, 2021 წ.)
•	ტრიპურას სახელმწიფო კურორტის განვითარების დაგეგმვა (ინდოეთი, 2023)
•	კონსულტაცია საქართველოს კურორტების განვითარების დაგეგმვისთვის (2024)

მიღებული აქვს შემდეგი ჯილდოები:

•	პირველი პრიზი სენდაის აეროპორტის დაგეგმვისთვის  (2014, მიაგი, იაპონია)
•	პირველი პრიზი ჩენგ დონგის ახალი ქალაქის,  ლონგზის ტბის ტერიტორიის დაგეგმვისთვის (2003, ჰეინანი, PRC) 
•	იუნესკოს მელინა მერკურის პრიზი (2005, კოგა პარკი, იბარაკი, იაპონია)
`,
    img: kenichi,
  },
  {
    id: 5,
    name: "დოქტორი კურტ ფონ სტორჩი",
    position: `„EuropeSpa med &amp; wellness GmbH, Wiesbaden“- ის აღმასრულებელი დირექტორი
„Quality in Health Prevention“-ის გენერალური მდივანი
გერმანიის ბაალნეოლოგიისა და კლიმატოლოგიის აკადემიის ვიცე პრეზიდენტი`,
    description: `დოქტორი კურტ ფონ სტორჩი  კომპანია EuropeSpa med & wellness GmbH-ის აღმასრულებელი დირექტორია.   იგი, ამავდროულად, არის e.V., ვისბადენის ჯანმრთელობის პრევენციის ხარისხის გენერალური მდივანი,  STORCH Water Consulting International-ის აღმასრულებელი დირექტორი,  ბალნეოლოგიისა და კლიმატოლოგიის აკადემიის (VBK e.V.) ვიცე-პრეზიდენტი, გერმანიის სამედიცინო სპა ექსპერტთა ასოციაციის პრეზიდენტი და გერმანიის სპა ასოციაციის სამეცნიერო წევრი. 
2009 წლამდე იყო ჰიდროგეოლოგების საერთაშორისო ასოციაციის (IAH)   მინერალური და თერმული წყლების კომისიის (CMTW) გენერალური მდივანი. 
მისი კომპეტენციები მოიცავს:    სამედიცინო და ველნეს-ობიექტებისთვის  ხარისხის სტანდარტებისა და სერტიფიცირების სისტემების შექმნას;    სასწავლო კურსების შედგენასა და ტრენინგების ჩატარებას შემდეგ თემატიკაზე:  თერმული წყალი., ტალახი და კლიმატი, როგორც თერაპიული აგენტები ბალნეოლოგიაში,  ხარისხის ასპექტები გამაჯანსაღებელ დაწესებულებებსა და სამედიცინო აბაზანებში , ასევე, კონსულტაციებს ველნეს ტურისტულ მიმართულებებში ადგილობრივი ბუნებრივი რესურსების , მათ შორის, თერმული წყლების გამოყენების საკითხებში. (1999 – 2005: Institut Fresenius, გერმანია)
ხარისხის უზრუნველყოფა მიკრობიოლოგიისა და ქიმიის მიმართულებით, ჯანმრთელობის კლინიკებისთვის,  ველნეს სასტუმროებისთვის, სპა და ჩამოსასხმელი კომპანიებისთვის (1994 –1998: UFZ გარემოსდაცვითი კვლევის ცენტრი, გერმანია).
განხორციელებული აქვს  მინერალური და თერმული წყლების კვლევები და დაცული აქვს სადოქტორო დისერტაცია თემაზე: სპა ბიზნესისთვის მინერალური და თერმული წყლების ხარისხის დაცვის ასპექტები.`,
    img: drCurt,
  },
  {
    id: 6,
    name: "დოქტორი მარკუს კოპლინი",
    position: `ჩრდილოეთ ამერიკის ბალნეოლოგიის ასოციაციის (BANA) პრეზიდენტი`,
    description: `დოქტორი მარკუს კოპლინი არის ჩრდილოეთ ამერიკის ბალნეოლოგიის
ასოციაციის (BANA) პრეზიდენტი. იგი არის ექიმი ნატუროპატი, სპეციალიზაციით
„ინტეგრაციული ფიზიკური და სარეაბილიტაციო მედიცინა“ და „ინტეგრაციული
ონკოლოგია“.
იგი ჰიდროთერმული მედიცინის წამყვანი სპეციალისტია ჩრდილოეთ ამერიკაში,
ამავდროულად, არის კურორტის The Springs Resort-ის (Pagosa Springs,
კოლორადოს შტატი) და Murrieta Hot Springs Resort-ის (კალიფორნიის შტატი)
სამედიცინო დირექტორი. მას აქვს 15 წელზე მეტხნიანი გამოცდილება
კომპლექსური და ქრონიკული დაავადებების მკურნალობაში, ტრადიციულ
მკურნალობასთან ერთად ჰიდროთერმული თერაპიის, კვების, ფიზიკური
მედიცინისა და ბუნებრივი სამკურნალო საშუალებების გამოყენებით.
დოქტორი კოპლინის ნაშრომები და სწავლება მოიცავს გამაჯანსაღებელი
კურორტების როლს 21-ე საუკუნის ჯანდაცვისა და ტურიზმის სფეროში. ის არის

ბალნეოლოგიისა და ჯანმრთელობის საკურორტო მედიცინის საერთაშორისო
ჟურნალის მთავარი რედაქტორი, და ავტორი წიგნისა, სახელწოდებით
„ჯანმრთელობის კურორტის მედიცინა“. მისი ამჟამინდელი საქმიანობა, ასევე,
მოიცავს კლინიკების ხელმძღვანელების კონსულტირებას პაციენტზე
ორიენტირებული მაღალხარისხიანი მომსახურების უზრუნველსაყოფად.`,
    img: coplin,
  },
  {
    id: 7,
    name: "ასოცირებული პროფესორი ლელა ფოცხვერაშვილი",
    position: `დირექტორის მოადგილე, სსიპ კურორტების განვითარების სააგენტო`,
    description: `ლელა ფოცხვერაშვილი 2022 წლიდან არის საქართველოს ეკონომიკისა და მდგრადი განვითარების სამინისტროს სსიპ კურორტების განვითარების სააგენტოს დირექტორის მოადგილე. 2016 წლიდან ხელმძღვანელობდა შპს ემთიეის საერთაშორისო ურთიერთობებისა და ანალიტიკის დეპარტამენტს. არის დიდი ბრიტანეთის ნიუ ანგლიის უნივერსიტეტის ასოცირებული პროფესორი და ილიას სახელმწიფო უნივერსიტეტის მოწვეული ლექტორი. 
ლელა ფოცხვერაშვილს აქვს 15-ზე მეტწლიანი გამოცდილება საჯარო და კერძო სექტორში, ადგილობრივ და საერთაშორისო ორგანიზაციებში ეკონომიკის, ტურიზმის, საერთაშორისო ურთიერთობების, ჰუმანიტარული სამართლისა და სხვა მიმართულებებში. მუშაობდა კონვენციებზე, სტრატეგიებსა და სამოქმედო გეგმებზე სახელმწიფო პოლიტიკის სხვადასხვა მიმართულებით. 
2012 წლიდან იყო აღმოსავლეთ პარტნიორობის და ვიშეგრადის ქვეყნების პროექტების მენეჯერი და ექსპერტი ეკონომიკური მდგრადობის, ტურიზმისა და სოციალურად დაუცველი ჯგუფების ინტეგრირების სფეროში.  
ლელა ფოცხვერაშვილი არის ამერიკის სწავლების ფონდის, პოლონეთის საგარეო საქმეთა სამინისტროსა და საერთაშორისო ვიშეგრადის ფონდის სტიპენდიანტი. ფლობს დიდი ბრიტანეთის ლანკასტერის უნივერსიტეტის მაგისტრის ხარისხს ჰუმანიტარულ მეცნიერებებში და თბილისის სახელმწიფო უნივერსიტეტის მაგისტრის ხარისხს საერთაშორისო ურთიერთობებში. ამჟამად არის თბილისის სახელმწიფო უნივერსიტეტის დოქტორანტი საერთაშორისო ურთიერთობების მიმართულებით. მისი უახლოესი პუბლიკაციაა „ეროვნული იდენტობის გავლენა საქართველოს საგარეო პოლიტიკაზე“. 
`,
    img: lela,
  },
  {
    id: 8,
    name: "ბენი პრეგენზერი",
    position: `„Pro excellence”-ის დამფუძნებელი`,
    description: `ბენი პრეგენზერი ალპური ტურიზმის ინდუსტრიის გამოცდილი ლიდერია. იგი ცნობილია თავისი ინოვაციური მიდგომებით კურორტების ზამთრისა და ზაფხულის აქტივობების გაუმჯობესებაში. 
კარიერა 1982 წელს, ავსტრიაში,  სათხილამურო ინსტრუქტორად დაიწყო და წლების შემდეგ მისმა საქმიანობამ მოიცვა კურორტების მართვა და განვითარება.  პრეგენზერის მუშაობა გამოირჩევა ალპურ კურორტებზე სტუმრებისთვის საუკეთესო გამოცდილებისა და კომფორტის  შექმნით. 
იგი განსაკუთრებით სათხილამურო კურორტებზე მოძრავი ხალიჩისა და დეპოების დანერგვაში იყო ჩართული, რამაც თხილამურებით სრიალი უფრო ხელმისაწვდომი გახადა ოჯახებისა და დამწყები მოთხილამურეებისთვის. 
2011 წლიდან 2023 წლამდე პრეგენზერი Fisser Bergbahnen GmbH-ის მმართველ დირექტორად მუშაობდა. მის პასუხისმგებლობაში საბაგიროების ოპერირების ზედამხედველობა, სათხილამურო ტრასების მართვა და ოთხსეზონური მომსახურებების, მათ შორის, ველოპარკების და ზაფხულის აქტივობების განვითარება შედიოდა. 
ზამთრის ტურიზმთან ერთად ზაფხულის ტურისტული ინფრასტრუქტურის განვითარების მისეულმა ხედვამ გადამწყვეტი როლი ითამაშა რეგიონის 4-სეზონიან კურორტად გარდაქმნაში.  მისი ლიდერული გამოცდილება ასევე მოიცავს Falls Creek-ის და Fiss-Ladis-ის სათხილამურო სკოლებისა და სათხილამურო ჩემპიონატების დეპარტამენტის მართვას, რამაც გაამყარა მისი გამოცდილება სათხილამურო კურორტების მართვაში. 
პრეგენზერმა მნიშვნელოვანი როლი შეასრულა საერთაშორისო მასშტაბით და განსაკუთრებული წვლილი შეიტანა ისეთო კურორტების განვითარების დაგეგმარებაში, როგორიცაა ფალს კრიკი (ავსტრალია), ნისეკო (იაპონია) და დონოვალი (სლოვაკეთი), ასევე პალანდოკენისა და კონაკლის (თურქეთი) განვითარების პოტენციალის შესწავლაში.  გარდა ამისა, პრეგენზერმა 2007 წელს დააარსა საკუთარი კომპანია Fiss-Consulting რომელიც  საკონსულტაციო მომსახურებას ეწევა სათხილამურო კურორტების მართვასა და განვითარებაში. 
2023 წელს მან დაარსა საკონსულტაციო და პროექტების განვითარების კომპანია, „Pro Excellence". კომპანია ნერგავს ინოვაციებს ალპური ტურიზმის სექტორში.
`,
    img: benny,
  },
  {
    id: 9,
    name: "ირაკლი ბურჭულაძე",
    position: `დირექტორი, “ემ თი ეი”`,
    description: `ირაკლი ბურჭულაძე არის ფინანსებსა და მენეჯმენტში მრავალწლიანი გამოცდილების მქონე პროფესინალი, რომელსაც აქვს 13 წლიანი გამოცდილება როგორც კერძო, ასევე საჯარო სექტორში. იგი ფლობს მაგისტრის ხარისხს ფინანსებში  და ბაკალავრის ხარისხს საერთაშორისო ეკონომიკურ ურთიერთობებში. მისი გამოცდილება კერძო სექტორში მოიცავს ბიზნეს მოდელების და ფინანსური გადაწყვეტილებების შემუშავებას, მართვის სტრატეგიებსა და სამოქმედო გეგმების გაწერას. მისი პროფესიონალური კარიერა საჯარო სექტორში დაიწყო ორ მთავარ რეფორმაზე მუშაობით, ეს გახლავთ საპენსიო და კაპიტალის ბაზრის რეფორმა. საპენსიო სააგენტოში  მუშაობის შემდეგ ირაკლი დაწინაურდა საქართველოს პრემიერ-მინისტრის აპარატის უფროსის მოადგილის თანამდებობაზე, სადაც მისი მთავარი პასუხისმგებლობა პრემიერის აპარატის ფინანსური პროცესების მართვა იყო. 
2022 წლიდან, როგორც შპს “ემ თი ეი”-ს დირექტორი იგი ხელმძღვანელობს საქართველოს ოთხ მთავარ სამთო სათხილამურო კურორტს, ესენია: გუდაური, ბაკურიანი, მესტია და გოდერძი. 
ირაკლი ბურჭულაძის ხელმძღვანელობით შპს “ემ თი ეი”-მ განახორციელა არაერთი ინიციატივა საქართველოს სამთო-სათხილამურო კურორტების განვითარების მიმართულებით. მისი ხელმძღვანელობის პერიოდში საქართველო გახდა Freeride World Tour-ის მასპინძელი ქვეყანა. მისმა წარმატებულმა თანამშრომლობამ FIS-თან განაპირობა  მსოფლიო ჩემპიონატის ყოველწლიური მასპინძლობა საქართველოს სათხილამურო კურორტებზე. შპს „ემ თი ეი“-ს დირექტორის პოზიციაზე ირაკლი სათავეში უდგას  ინფრასტრუქტურულ პროექტებს რომლებიც აუმჯობესებს კურორტის ობიექტების კეთილმოწყობასა და მათ გამართულ ოპერირებას. მისი ამ პროზიციაზე მუშაობის შედეგად საქართველო აგრძელებს პოზიციონირებას ზამთრის სპორტის მსოფლიო ასპარეზზე. 

`,
    img: ira,
  },
  {
    id: 10,
    name: "დოქტორი ჯონ სოდონი",
    position: `გარემოსდაცვითი ეკონომისტი, ევროპაში, აზიასა და წყნარი ოკეანის ქვეყნებში`,
    description: `ჯონ სოდონი  გარემოსდაცვითი ეკონომისტია, ევროპაში, აზიასა და წყნარი ოკეანის ქვეყნებში  18-ზე მეტწლიანი პროფესიული გამოცდილებით. იგი ფლობს აღმოსავლეთ ანგლიის უნივერსიტეტის (დიდი ბრიტანეთი) ეკონომიკის დოქტორის ხარისხს და ლონდონის უნივერსიტეტის (დიდი ბრიტანეთი) მაგისტრის ხარისხს. ჯონი ინტენსიურად მუშაობდა კლიმატთან, ჰიდროენერგეტიკასა და განახლებად ენერგიასთან, მწვანე ურბანულ განვითარებასთან, ბუნებაზე დაფუძნებულ გადაწყვეტილებებსა და მდგრად ტურიზმთან დაკავშირებულ პროექტებზე.  ამჟამად იგი დასაქმებულია სხვადასხვა სამთავრობო უწყებებსა და ისეთ საერთაშორისო ორგანიზაციებში, როგორიცაა აზიის განვითარების ბანკი (ADB), მსოფლიო ბანკი (WB) და გაეროს განვითარების პროგრამა (UNDP). საქართველოს გარდა, იგი მუშაობდა ტურისტულ პროექტებზე ფიჯიში, ნეპალსა და ვიეტნამში.`,
    img: sodoni,
  },
];
